/**
 * Ilustraciones de los modales de límite de plan. Son decorativas: el modal ya
 * pone el título accesible, así que van marcadas como tales.
 */

/** Ficha con el contador de vistas en cero. */
export function NoViewsIllustration() {
  return (
    <svg
      width="200"
      height="132"
      viewBox="0 0 200 132"
      fill="none"
      aria-hidden="true"
    >
      <rect
        x="30"
        y="30"
        width="140"
        height="86"
        rx="12"
        fill="#F6F8FC"
        stroke="#E4E9F2"
      />
      <rect
        x="22"
        y="20"
        width="140"
        height="86"
        rx="12"
        fill="#fff"
        stroke="#DCE3EF"
      />
      <rect x="38" y="38" width="62" height="7" rx="3.5" fill="#DCE3EF" />
      <rect x="38" y="53" width="94" height="7" rx="3.5" fill="#EDF1F8" />
      <rect x="38" y="68" width="76" height="7" rx="3.5" fill="#EDF1F8" />
      <rect x="38" y="83" width="44" height="7" rx="3.5" fill="#EDF1F8" />
      <circle cx="146" cy="94" r="30" fill="#fff" />
      <circle
        cx="146"
        cy="94"
        r="24"
        fill="#FEF4E6"
        stroke="#F0A83A"
        strokeWidth="2.5"
        strokeDasharray="4 5"
      />
      <text
        x="146"
        y="101"
        textAnchor="middle"
        fontFamily="inherit"
        fontSize="19"
        fontWeight="700"
        fill="#B5741A"
      >
        0
      </text>
    </svg>
  );
}

/** Tres ramas de un árbol: dos ocupadas y la tercera con candado. */
export function SearchProfileLimitIllustration() {
  return (
    <svg
      width="200"
      height="132"
      viewBox="0 0 200 132"
      fill="none"
      aria-hidden="true"
    >
      <circle cx="100" cy="26" r="13" fill="#0B4FD6" />
      <path
        d="M100 39v20M100 59H40v14M100 59h60v14M100 59v14"
        stroke="#DCE3EF"
        strokeWidth="2"
      />
      <path
        d="M160 59v14"
        stroke="#E4E9F2"
        strokeWidth="2"
        strokeDasharray="4 4"
      />
      <rect
        x="16"
        y="73"
        width="48"
        height="38"
        rx="10"
        fill="#EAF1FF"
        stroke="#0B4FD6"
        strokeWidth="1.5"
      />
      <rect
        x="76"
        y="73"
        width="48"
        height="38"
        rx="10"
        fill="#EAF1FF"
        stroke="#0B4FD6"
        strokeWidth="1.5"
      />
      <rect
        x="136"
        y="73"
        width="48"
        height="38"
        rx="10"
        fill="#F6F8FC"
        stroke="#C9D3E5"
        strokeWidth="1.5"
        strokeDasharray="5 5"
      />
      <rect
        x="28"
        y="86"
        width="24"
        height="5"
        rx="2.5"
        fill="#0B4FD6"
        opacity=".55"
      />
      <rect
        x="28"
        y="96"
        width="16"
        height="5"
        rx="2.5"
        fill="#0B4FD6"
        opacity=".28"
      />
      <rect
        x="88"
        y="86"
        width="24"
        height="5"
        rx="2.5"
        fill="#0B4FD6"
        opacity=".55"
      />
      <rect
        x="88"
        y="96"
        width="16"
        height="5"
        rx="2.5"
        fill="#0B4FD6"
        opacity=".28"
      />
      <rect
        x="152"
        y="84"
        width="16"
        height="12"
        rx="3.5"
        fill="none"
        stroke="#8A93A6"
        strokeWidth="2"
      />
      <path d="M155 84v-4a5 5 0 0110 0v4" stroke="#8A93A6" strokeWidth="2" />
      <path
        d="M160 100v3"
        stroke="#8A93A6"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

/** Barras de mercado con la tendencia punteada. */
export function MarketIntelligenceIllustration() {
  return (
    <svg
      width="200"
      height="132"
      viewBox="0 0 200 132"
      fill="none"
      aria-hidden="true"
    >
      <rect
        x="26"
        y="18"
        width="148"
        height="96"
        rx="12"
        fill="#F6F8FC"
        stroke="#E4E9F2"
      />
      <rect x="42" y="78" width="16" height="20" rx="4" fill="#C9D3E5" />
      <rect x="66" y="64" width="16" height="34" rx="4" fill="#C9D3E5" />
      <rect x="90" y="70" width="16" height="28" rx="4" fill="#C9D3E5" />
      <rect
        x="114"
        y="46"
        width="16"
        height="52"
        rx="4"
        fill="#17B667"
        opacity=".35"
      />
      <rect
        x="138"
        y="34"
        width="16"
        height="64"
        rx="4"
        fill="#17B667"
        opacity=".55"
      />
      <path
        d="M46 62l24-16 24 8 24-20 24-12"
        stroke="#0B4FD6"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="6 6"
      />
      <circle cx="142" cy="96" r="24" fill="#fff" />
      <circle cx="142" cy="96" r="19" fill="#E7F7EE" />
      <path
        d="M134 98l6 6 12-14"
        stroke="#0E9A55"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Burbujas de conversación con la chispa de IA y los clientes conectados. */
export function AiChatIllustration() {
  return (
    <svg
      width="216"
      height="140"
      viewBox="0 0 216 140"
      fill="none"
      aria-hidden="true"
    >
      <rect
        x="24"
        y="10"
        width="168"
        height="82"
        rx="14"
        fill="#F6F8FC"
        stroke="#E4E9F2"
      />
      <rect x="86" y="22" width="94" height="20" rx="10" fill="#0B4FD6" />
      <rect
        x="96"
        y="30"
        width="60"
        height="4"
        rx="2"
        fill="#fff"
        opacity=".55"
      />
      <circle cx="48" cy="60" r="11" fill="#fff" stroke="#E4E9F2" />
      <path
        d="M48 54l1.7 3.9 3.9 1.7-3.9 1.7L48 65l-1.7-3.7-3.9-1.7 3.9-1.7L48 54z"
        fill="#8B5CF6"
      />
      <rect
        x="66"
        y="50"
        width="112"
        height="32"
        rx="9"
        fill="#fff"
        stroke="#E4E9F2"
      />
      <rect x="76" y="58" width="66" height="5" rx="2.5" fill="#DCE3EF" />
      <rect
        x="76"
        y="69"
        width="34"
        height="5"
        rx="2.5"
        fill="#8B5CF6"
        opacity=".5"
      />
      <rect x="150" y="69" width="20" height="5" rx="2.5" fill="#EDF1F8" />
      <path
        d="M108 92v14M108 106H62v10M108 106h46v10"
        stroke="#C9D3E5"
        strokeWidth="2"
        strokeDasharray="5 5"
      />
      <rect
        x="26"
        y="116"
        width="72"
        height="22"
        rx="11"
        fill="#fff"
        stroke="#DCE3EF"
      />
      <circle cx="40" cy="127" r="5" fill="#C9D3E5" />
      <rect x="50" y="124.5" width="36" height="5" rx="2.5" fill="#E4E9F2" />
      <rect
        x="118"
        y="116"
        width="72"
        height="22"
        rx="11"
        fill="#fff"
        stroke="#DCE3EF"
      />
      <circle cx="132" cy="127" r="5" fill="#C9D3E5" />
      <rect x="142" y="124.5" width="36" height="5" rx="2.5" fill="#E4E9F2" />
    </svg>
  );
}
